import merge from "lodash/merge";
import { ChartCandle, LineData, LineSeriesOptions, Series } from "../chart.typings";
import BaseChartSeries from "./baseSeries";
import { lineSeriesOptions } from "../../../assets/constants";
import { getLineTypeFromChartSubType } from "../../../util/chart";
import { ChartSubType, ChartType } from "../../../proto/generated/chart";
import { DeepPartial, LineType } from "lightweight-charts";
import { IndicatorOutput_OutputStyle } from "../../../proto/generated/indicator";
import { evaluateExpression } from "../../../util/safeExpressionEval";
import { ChartLineStyle } from "../../../pages/chartPage/ChartPage";

class LineSeries extends BaseChartSeries<LineData, LineSeriesOptions> {

    addSeriesToChart() {
        return this.chart.chartApi.addLineSeries(this.seriesOptions)
    }

    getDefaultOptions(): LineSeriesOptions {
        const { thickness } = this.config;
        let lineType = getLineTypeFromChartSubType(this.config.chartSubType || ChartSubType.SIMPLE);

        if (this.config.chartType === ChartType.LINE && this.config.chartSubType === ChartSubType.STEP_LINE) {
            lineType = LineType.Simple;
        }

        const options: LineSeriesOptions = {
            lineType,
            source: "close",
            lineWidth: thickness || 2
        };
        return merge({...lineSeriesOptions}, options, this.options)
    }
    onOptionsUpdate(options: DeepPartial<LineSeriesOptions>): void {
        if ('source' in options) {
            this._setData(this.rawData, this.metadata)
        }
    }
    onConfigUpdate(oldConfig: Series): void {
        if (oldConfig.chartSubType !== this.config.chartSubType) {
            this.updateOptions({})
        }
    }

    generateSeriesData(data: ChartCandle[], metadata: Record<string, any> = {}): LineData[] {
        const result: LineData[] = [];
        const open: number[] = new Array(data.length);
        const close: number[] = new Array(data.length);
        const series: number[] = new Array(data.length);

        const {color: seriesColor} = this.seriesApi.options()

        const {color: metaColor, lineStyle } = metadata;
        const {color: configColor} = this.config;
        const isColorHexCode = metaColor && RegExp(/^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/).test(metaColor)
        const color = isColorHexCode ? configColor : metaColor;
        const source = this.seriesOptions.source

        if (isColorHexCode && seriesColor !== color) {
            this.seriesApi.applyOptions({color})
        }

        if (lineStyle) {
            this.updateOptions({
                lineStyle: ChartLineStyle[lineStyle] as any
            })
        }


        data.forEach((candle, i) => {
            if (candle[source] === undefined) return;
            open[i] = candle.open;
            close[i] = candle.close;
            series[i] = candle.series || 0
            let candleColor = color;
            if (isNaN(candle[source] as number) && this.config.style === IndicatorOutput_OutputStyle.WITH_BREAKS) {
                candleColor = "transparent"
            } else if (!isColorHexCode && candleColor) {
                candleColor = evaluateExpression<string>(metaColor, { open, close, series, candle, i })
            }

            result.push({
                ...candle,
                value: candle[source] as number,
                color: candleColor && (candleColor == "transparent" || !isColorHexCode) ? candleColor : undefined
            })

        })

        return result;
    }

}

export default LineSeries;